import { EMPTY_FIELD } from 'constants/emptyField';

import { useRecordContext } from 'react-admin';
import { WorkTeam } from 'types/embedded/workTeam';

export const ProviderAccountsManagerField: React.FC = () => {
  const record = useRecordContext<WorkTeam>();

  if (!record?.manager?.firstName && !record?.manager?.lastName) {
    return <>{EMPTY_FIELD}</>;
  }

  return <>{`${record?.manager?.firstName} ${record?.manager?.lastName}`}</>;
};
